import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { app_routes } from './app.routes';

@NgModule({
  imports: [
    RouterModule.forRoot(app_routes),
    StoreRouterConnectingModule.forRoot()
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
